const clamp = (value, min, max) => Math.min(max, Math.max(min, value))

export default class State {
  constructor() {
    this.hoveredVibeId = null
    this.selectedVibeIds = []
    this.selectedClusterId = null
    this.dynamics = {
      gravityStrength: 0.9,
      driftIntensity: 0.55,
      repulsionStrength: 0.95,
      clusterStabilization: 0.72
    }
  }

  setHoveredVibe(vibe) {
    this.hoveredVibeId = vibe?.id ?? null
  }

  setSelectedVibe(vibe, options = {}) {
    if (!vibe) {
      this.selectedVibeIds = []
      return
    }

    const { append = false } = options

    if (append) {
      const isSelected = this.selectedVibeIds.includes(vibe.id)
      this.selectedVibeIds = isSelected
        ? this.selectedVibeIds.filter(id => id !== vibe.id)
        : [...this.selectedVibeIds, vibe.id]
      return
    }

    this.selectedVibeIds = this.selectedVibeIds.length === 1 && this.selectedVibeIds[0] === vibe.id
      ? []
      : [vibe.id]
  }

  clearSelectedVibes() {
    this.selectedVibeIds = []
  }

  setSelectedCluster(clusterId) {
    this.selectedClusterId = clusterId ?? null
  }

  clearSelections() {
    this.selectedVibeIds = []
    this.selectedClusterId = null
  }

  setDynamicsValue(key, value) {
    if (!(key in this.dynamics)) {
      return
    }

    this.dynamics[key] = clamp(Number(value), 0, 2)
  }
}
